import axios from '@plugins/axios';

class ResultadoService {
    getList(params = {}, options = {}) {
        return axios({
            url: `operadora/resultados/`,
            method: 'GET',
            params,
            ...options
        });
    }
    getAvailableList(params = {}, options = {})  {
        return axios({
            url: `operadora/resultados/available/`,
            method: 'GET',
            params,
            ...options
        });
    }
}

export const BaseResultadoService = ResultadoService

export default new ResultadoService();